import Layout from "@/views/layout";
export default [
    // 登录页面
    {
        path: "/login",
        name: "Login",
        component: () => import("@/views/login/login"),
        hidden: true,
    },
    {
        path: "/404",
        component: () => import("@/views/exception/404"),
        hidden: true,
    },
    {
        path: "",
        redirect: "/login",
        hidden: true,
    },
    // 海逊特色页面
    {
        path: "/purchase",
        component: () => import("@/views/home/purchase"),
        hidden: true,
    },
    {
        path: "",
        redirect: "/purchase",
        hidden: true,
    },
    // 注册页面
    {
        path: "/Register",
        component: () => import("@/views/login/Register"),
        hidden: true,
    },
    {
        path: "",
        redirect: "/Register",
        hidden: true,
    },
    // 帮助页面
    {
        path: "/help",
        component: () => import("@/views/home/help"),
        hidden: true,
    },
    {
        path: "",
        redirect: "/help",
        hidden: true,
    },
    // 忘记密码页面
    {
        path: "/forget",
        component: () => import("@/views/login/forget"),
        // redirect: '/forget',
        hidden: true,
    },
    {
        path: "",
        redirect: "/forget",
        hidden: true,
    },
    {
        path: "/policy",
        component: () => import("@/views/login/policy"),
        hidden: true,
    },
    {
        path: "",
        redirect: "/policy",
        hidden: true,
    },
    // {
    //   path: '/use',
    //   component: () => import('@/views/login/use'),
    //   hidden: true,
    // },
    // {
    //   path: '',
    //   redirect: '/use',
    //   hidden: true
    // },
    // 首页
    {
        path: "/Thome",
        component: () => import("@/views/home/Thome"),
        hidden: true,
    },
    // 首页
    {
        path: "/NoRole",
        component: () => import("@/views/home/NoRole"),
        hidden: true,
    },
    // ai辅助页面
    {
        path: "/AIAssisted",
        component: () => import("@/views/ozon/product/components/AIAssisted"),
        hidden: true,
    },

    //菜单栏路由配置-------------------------------------------------------
    {
        path: "/box",
        component: Layout,
        meta: { title: " 首页", icon: "icon-shangcheng" },
        redirect: "noredirect",
        children: [
            {
                path: "Thome",
                name: "Thome",
                component: () => import("@/views/home/Thome"),
                meta: { title: " 首页", isClose: true },
            },
            {
                path: "SkuManagement",
                name: "SkuManagement",
                component: () => import("@/views/IndependentStand/ManagementSKU"),
                meta: { title: "SKU管理" },
            },
            {
                path: "ClassificationManagement",
                name: "ClassificationManagement",
                component: () => import("@/views/IndependentStand/Classification"),
                meta: { title: "分类管理" },
            },
            // {
            //   path: 'BmChannel',
            //   name: 'BmChannel',
            //   component: () => import('@/views/ResourceChannels/ChannelsBM'),
            //   meta: { title: 'BM渠道' },
            // },
            // {
            //   path: 'FbPersonalNumberChannel',
            //   name: 'FbPersonalNumberChannel',
            //   component: () => import('@/views/ResourceChannels/PersonalChannel'),
            //   meta: { title: 'FB个人号渠道' },
            // },
            // {
            //   path: 'FbAdvertiserChannel',
            //   name: 'FbAdvertiserChannel',
            //   component: () => import('@/views/ResourceChannels/AdvertiserChannel'),
            //   meta: { title: 'FB广告户渠道' },
            // },
            // {
            //   path: 'ServerManagement',
            //   name: 'ServerManagement',
            //   component: () => import('@/views/AccountDebugging/ServerManagement'),
            //   meta: { title: '服务器管理' },
            // },
            // {
            //   path: 'DomainNameResources',
            //   name: 'DomainNameResources',
            //   component: () => import('@/views/AccountDebugging/DomainResource'),
            //   meta: { title: '域名资源' },
            // },
            // {
            //   path: 'FbPersonalAccount',
            //   name: 'FbPersonalAccount',
            //   component: () => import('@/views/AccountDebugging/PersonalFB'),
            //   meta: { title: 'FB个人号' },
            // },
            // {
            //   path: 'FbAdvertiser',
            //   name: 'FbAdvertiser',
            //   component: () => import('@/views/AccountDebugging/AdvertisingFB'),
            //   meta: { title: 'FB广告户' },
            // },
            {
                path: "AccreditTest",
                name: "AccreditTest",
                component: () => import("@/views/AccreditTest/index"),
                meta: { title: "sp-api授权" },
            },
            {
                path: "ShopifyLicensing",
                name: "ShopifyLicensing",
                component: () => import("@/views/AccreditTest/ShopifyLicensing"),
                meta: { title: "shopify授权" },
            },
            {
                path: "ShoplazzaAuthorize",
                name: "ShoplazzaAuthorize",
                component: () => import("@/views/AccreditTest/ShoplazzaAuthorize"),
                meta: { title: "shoplazza授权" },
            },

            {
                path: "AllegroAuthorize",
                name: "AllegroAuthorize",
                component: () => import("@/views/AccreditTest/AllegroAuthorize"),
                meta: { title: "Allegro授权" },
            },
            {
                path: "AliexpressAuthorize",
                name: "AliexpressAuthorize",
                component: () => import("@/views/AccreditTest/AliexpressAuthorize"),
                meta: { title: "Aliexpress授权" },
            },
            {
                path: "WalmartAuthorize",
                name: "WalmartAuthorize",
                component: () => import("@/views/AccreditTest/WalmartAuthorize"),
                meta: { title: "Walmart授权" },
            },
            {
                path: "OzonAuthorize",
                name: "OzonAuthorize",
                component: () => import("@/views/AccreditTest/OzonAuthorize"),
                meta: { title: "Ozon授权" },
            },
            {
                path: "CoupangAuthorize",
                name: "CoupangAuthorize",
                component: () => import("@/views/AccreditTest/CoupangAuthorize"),
                meta: { title: "Coupang授权" },
            },
            // {
            //   path: 'ShoplusAuthorize',
            //   name: 'ShoplusAuthorize',
            //   component: () => import('@/views/AccreditTest/ShoplusAuthorize'),
            //   meta: { title: 'Shoplus授权' },
            // },
            {
                path: "ShopeeAuthorize",
                name: "ShopeeAuthorize",
                component: () => import("@/views/shopee/authorize.vue"),
                meta: { title: "Shopee授权" },
            },
            {
                path: "ShoplineAuthorize",
                name: "ShoplineAuthorize",
                component: () => import("@/views/AccreditTest/ShoplineAuthorize"),
                meta: { title: "Shopline授权" },
            },
            {
                path: "TikTokAuthorize",
                name: "TikTokAuthorize",
                component: () => import("@/views/AccreditTest/TikTokAuthorize"),
                meta: { title: "TikTok授权" },
            },
            // {
            //   path: 'PayPalAuthorize',
            //   name: 'PayPalAuthorize',
            //   component: () => import('@/views/AccreditTest/PaypalAuthorize'),
            //   meta: { title: 'PayPal授权' },
            // },
            //用户管理
            {
                path: "UserManage",
                name: "UserManage",
                component: () => import("@/views/UserManage"),
                meta: { title: " 用户管理" },
            },
            //工单
            {
                path: "repairOrder",
                name: "repairOrder",
                component: () => import("@/views/home/repairOrder"),
                meta: { title: " 工单" },
            },
            //公司管理
            {
                path: "OverallSituation",
                name: "OverallSituation",
                component: () => import("@/views/dashboard/OverallSituation"),
                meta: { title: "公司管理" },
            },
            //公司主页
            {
                path: "analysis",
                component: () => import("@/views/dashboard/analysis"),
                meta: { title: "公司主页", noCache: true },
                name: "analysis",
            },
            //公司管理_暂时无用的路由
            {
                path: "details",
                component: () => import("@/views/dashboard/details"),
                name: "details",
                hidden: true,
            },
            {
                path: "notice",
                component: () => import("@/views/dashboard/notice"),
                name: "notice",
                hidden: true,
            },
            {
                path: "notice_details",
                component: () => import("@/views/dashboard/notice_details"),
                name: "notice_details",
                hidden: true,
            },
            //商品管理_我的产品_商品汇总
            {
                path: "conmmoditySummary",
                name: "conmmoditySummary",
                component: () => import("@/views/commodity/product/Release"),
                meta: { title: "商品汇总" },
            },
            //商品管理_我的产品_sku信息管理
            {
                path: "skuInfoManagement",
                name: "skuInfoManagement",
                component: () =>
                    import("@/views/commodity/product/skuInfoManagement"),
                meta: { title: "sku信息管理" },
            },
            //商品管理_我的产品_待发布产品
            {
                path: "productsToBeReleased",
                name: "productsToBeReleased",
                component: () => import("@/views/commodity/product/summary"),
                meta: { title: "待发布产品" },
            },
            //商品管理_我的产品_待发布产品新页面
            {
                path: "amazonListing",
                name: "amazonListing",
                component: () => import("@/views/commodity/product/summary2"),
                meta: { title: "亚马逊listTing" },
            },
            //商品管理_图片管理
            {
                path: "imageManagement",
                name: "imageManagement",
                component: () => import("@/views/commodity/product/imageManagement"),
                meta: { title: "图片管理" },
            },
            //商品管理_网络产品
            // {
            //     path: "NetworkProducts",
            //     name: "NetworkProducts",
            //     component: () => import("@/views/commodity/product/NetworkProducts"),
            //     meta: { title: "网络产品" },
            // },
            //亚马逊产品库
            {
                path: "AmazonProductLibrary",
                name: "AmazonProductLibrary",
                component: () => import("@/views/commodity/product/amazonProductLibrary"),
                meta: { title: "产品库" },
            },
            //产品库_管理分类
            {
                path: "SortAndAttribute",
                name: "SortAndAttribute",
                component: () => import("@/views/commodity/product/sortAndAttribute"),
                meta: { title: "管理分类" },
            },
            //亚马逊产品_在线ListTing
            {
                path: "onlineListing",
                name: "onlineListing",
                component: () => import("@/views/commodity/product/onlineListing"),
                meta: { title: "在线listTing" },
            },
            //商品管理_我的产品_创建新产品
            {
                path: "createANEWproduct",
                name: "createANEWproduct",
                component: () => import("@/views/commodity/product/EstablishProduct"),
                meta: { title: "创建新产品" },
            },
            // 数据看板
            // {
            //     path: "DataDashboard",
            //     name: "DataDashboard",
            //     component: () => import("@/views/DataDashboard"),
            //     meta: { title: "数据看板" },
            // },
            {
                path: "productDisplay",
                name: "productDisplay",
                component: () => import("@/views/ozon/product/productDisplay"),
                meta: { title: "产品刊登" },
            },
            {
                path: "onlineProduct",
                name: "onlineProduct",
                component: () => import("@/views/ozon/product/onlineProduct"),
                meta: { title: "在线产品" },
            },
            {
                path: "WalmartProductDisplay",
                name: "WalmartProductDisplay",
                component: () =>
                    import("@/views/Walmart/productDisplay"),
                meta: { title: "Walmart产品刊登" },
            },
            {
                path: "WalmartOnlineProduct",
                name: "WalmartOnlineProduct",
                component: () =>
                    import("@/views/Walmart/onlineProduct"),
                meta: { title: "Walmart在线产品" },
            },
            {
                path: "AllegroProductDisplay",
                name: "AllegroProductDisplay",
                component: () =>
                    import("@/views/AllegroProductAllegro/productDisplay"),
                meta: { title: "Allegro产品刊登" },
            },
            {
                path: "AllegroOnlineProduct",
                name: "AllegroOnlineProduct",
                component: () =>
                    import("@/views/AllegroProductAllegro/onlineProduct"),
                meta: { title: "Allegro在线产品" },
            },
            {
                path: "AllegroShopTemplate",
                name: "AllegroShopTemplate",
                component: () => import("@/views/AllegroProductAllegro/shopTemplate"),
                meta: { title: "Allegro店铺模板" },
            },
            {
                path: "AllegroCategoryTemplate",
                name: "AllegroCategoryTemplate",
                component: () =>
                    import("@/views/AllegroProductAllegro/categoryTemplate"),
                meta: { title: "Allegro分类模板" },
            },
            {
                path: "BaseProduct",
                name: "BaseProduct",
                component: () => import("@/views/BaseProduct/baseProduct"),
                meta: { title: "产品中心" },
            },
            // 广告套利
            // {
            //   path: "Workspace",
            //   name: "Workspace",
            //   component: () => import("@/views/AdvertisingArbitrage/workspace"),
            //   meta: { title: "工作区" },
            // },
            // {
            //   path: "RevenueIntegration",
            //   name: "RevenueIntegration",
            //   component: () => import("@/views/AdvertisingArbitrage/revenueIntegration"),
            //   meta: { title: "收入集成" },
            // },
            // {
            //   path: "DomainManagement",
            //   name: "DomainManagement",
            //   component: () => import("@/views/AdvertisingArbitrage/domainManagement"),
            //   meta: { title: "域名管理" },
            // },
            // {
            //   path: "IntegratedManagement",
            //   name: "IntegratedManagement",
            //   component: () => import("@/views/AdvertisingArbitrage/integratedManagement"),
            //   meta: { title: "转换API" },
            // },
            // {
            //   path: "urlBuilder",
            //   name: "urlBuilder",
            //   component: () => import("@/views/AdvertisingArbitrage/urlBuilder"),
            //   meta: { title: "url构建器" },
            // },
            // {
            //   path: "offersManagement",
            //   name: "offersManagement",
            //   component: () => import("@/views/AdvertisingArbitrage/offersManagement"),
            //   meta: { title: "offer管理" },
            // },
            // {
            //   path: "campaignsManagement",
            //   name: "campaignsManagement",
            //   component: () => import("@/views/AdvertisingArbitrage/campaignsManagement"),
            //   meta: { title: "campaigns管理" },
            // },
            // {
            //   path: "adReport",
            //   name: "adReport",
            //   component: () => import("@/views/AdvertisingArbitrage/adReport"),
            //   meta: { title: "报告" },
            // },
            //商品管理_Shopee_创建新产品
            // {
            //   path: 'ShopeeProductCreation',
            //   name: 'ShopeeProductCreation',
            //   component: () =>
            //     import('@/views/Shopee/EstablishProduct'),
            //   meta: { title: 'Shopee产品创建' },
            // },
            //商品管理_我的产品_编辑产品
            {
                path: "editProduct/:id/:pageType",
                name: "editProduct",
                component: () => import("@/views/commodity/product/EstablishProduct"),
                meta: { title: "编辑产品" },
            },
            //商品管理_我的产品_产品孵化器
            {
                path: "ProductIncubator",
                name: "ProductIncubator",
                component: () => import("@/views/commodity/product/Incubator"),
                meta: { title: "产品孵化器" },
            },
            //商品管理_我的产品_产品回收站
            {
                path: "productRecycleBin",
                name: "productRecycleBin",
                component: () =>
                    import("@/views/commodity/product/productRecycleBin"),
                meta: { title: "产品回收站" },
            },
            //商品管理_亚马逊商品_在线产品
            {
                path: "onlineProducts",
                name: "onlineProducts",
                component: () => import("@/views/commodity/Amazon/onlineProducts"),
                meta: { title: "在线产品" },
            },
            //商品管理_亚马逊商品_产品跟卖
            {
                path: "productsAndSale",
                name: "productsAndSale",
                component: () =>
                    import("@/views/commodity/Amazon/productsFollowSale"),
                meta: { title: "产品跟卖" },
            },
            //商品管理_产品分享
            {
                path: "productSharing",
                name: "productSharing",
                component: () => import("@/views/commodity/share/share"),
                meta: { title: "产品分享" },
            },
            //商品管理_通用设置
            {
                path: "generalSettings",
                name: "generalSettings",
                component: () => import("@/views/commodity/commonPage"),
                meta: { title: "通用设置" },
            },
            //订单管理_FBM订单
            {
                path: "FBMorder",
                name: "FBMorder",
                component: () => import("@/views/webChat/FBMOrder"),
                meta: { title: "FBM订单" },
            },
            //订单管理_FBM订单
            {
                path: "orderBoard",
                name: "orderBoard",
                component: () => import("@/views/webChat/orderBoard"),
                meta: { title: "订单管理" },
            },
            //订单管理_FBA订单
            {
                path: "FBAorder",
                component: () => import("@/views/webChat/FBAOrder"),
                meta: { title: "FBA订单" },
                name: "FBAorder",
            },
            //财务管理_财务审批
            {
                path: "Approval",
                name: "Approval",
                component: () => import("@/views/Finance/Approval/ApprovalMain"),
                meta: { title: "财务审批" },
            },
            //财务管理_汇款账号
            {
                path: "Remittance",
                name: "Remittance",
                component: () => import("@/views/Finance/Remittance"),
                meta: { title: "汇款账号" },
            },
            //财务管理_公司财务_费用对账
            {
                path: "costReconciliation/:activeName?",
                name: "costReconciliation",
                component: () => import("@/views/Finance/company/Cost"),
                meta: { title: "费用对账" },
            },
            //财务管理_公司财务_扣款明细
            {
                path: "detailsOfDeduction",
                name: "detailsOfDeduction",
                component: () => import("@/views/Finance/company/Deduction"),
                meta: { title: "扣款明细" },
            },
            //财务管理_业绩报表_提成结算明细
            {
                path: "CommissionSettlementDetails",
                name: "CommissionSettlementDetails",
                component: () =>
                    import("@/views/Finance/CommissionSettlementDetails"),
                meta: { title: "薪资结算" },
            },
            //财务管理_业绩报表_新增产品
            {
                path: "addNewProduct",
                name: "addNewProduct",
                component: () => import("@/views/Finance/results/addNewProduct"),
                meta: { title: "新增产品" },
            },
            //财务管理_备用金审批
            {
                path: "ReserveApproval",
                name: "ReserveApproval",
                component: () => import("@/views/Finance/Procurement_approval"),
                meta: { title: "备用金审批" },
            },
            //财务管理_备用金明细
            {
                path: "reserveFund",
                name: "reserveFund",
                component: () => import("@/views/Finance/reserveFund"),
                meta: { title: "备用金明细" },
            },
            //财务管理_店铺费用_冻结记录
            {
                path: "FreezeRecords",
                name: "FreezeRecords",
                component: () => import("@/views/Finance/Shopcharges/FreezeRecords"),
                meta: { title: "冻结记录" },
            },
            //财务管理_店铺费用_信用卡管理
            {
                path: "CreditCardManagement",
                name: "XykAdministration",
                component: () =>
                    import("@/views/Finance/Shopcharges/XykAdministration"),
                meta: { title: "信用卡管理" },
            },
            //财务管理_店铺费用_信用卡还款
            {
                path: "CreditCardPayments",
                name: "CreditCardPayments",
                component: () => import("@/views/Finance/Shopcharges/repayment"),
                meta: { title: "信用卡还款" },
            },
            //财务管理_店铺费用_亚马逊收款明细
            {
                path: "AmazonCollectionDetails",
                name: "AmazonCollectionDetails",
                component: () => import("@/views/Finance/Shopcharges/Detailed"),
                meta: { title: "亚马逊收款明细" },
            },
            //财务管理_店铺费用_亚马逊交易报告
            {
                path: "AmazonSettlement",
                name: "AmazonSettlement",
                component: () => import("@/views/Finance/Shopcharges/AmazonSettlement"),
                meta: { title: "亚马逊交易报告" },
            },
            //财务管理_店铺费用_推广收益
            {
                path: "Promotionrevenue",
                name: "Promotionrevenue",
                component: () => import("@/views/Finance/Promotionrevenue"),
                meta: { title: "推广收益" },
            },
            //财务管理_店铺费用_发放记录
            {
                path: "Revenuerecord",
                name: "Revenuerecord",
                component: () => import("@/views/Finance/Revenuerecord"),
                meta: { title: "发放记录" },
            },
            //财务管理_店铺费用_店铺余额
            {
                path: "SellerBalance",
                name: "SellerBalance",
                component: () => import("@/views/Finance/SellerBalance"),
                meta: { title: "店铺余额" },
            },
            //财务管理_独立站业绩_费用导入
            {
                path: "FeeImport",
                name: "FeeImport",
                component: () =>
                    import("@/views/Finance/Independent/FeeImport/FeeImport"),
                meta: { title: "费用导入" },
            },
            //财务管理_独立站业绩_普货业绩
            {
                path: "GeneralCargoPerformance",
                name: "GeneralCargoPerformance",
                component: () =>
                    import(
                        "@/views/Finance/Independent/GeneralCargoPerformance/GeneralCargoPerformance"
                    ),
                meta: { title: "普货业绩" },
            },
            //财务管理_独立站业绩_COD业绩
            {
                path: "CodPerformance",
                name: "CodPerformance",
                component: () =>
                    import("@/views/Finance/Independent/CodPerformance/CodPerformance"),
                meta: { title: "COD业绩" },
            },
            //财务管理_独立站业绩_利润统计
            {
                path: "ProfitStatistics",
                name: "ProfitStatistics",
                component: () =>
                    import(
                        "@/views/Finance/Independent/ProfitStatistics/ProfitStatistics"
                    ),
                meta: { title: "利润统计" },
            },
            //财务管理_独立站业绩_广告费核账
            {
                path: "AdvertisingFeeCheck",
                name: "AdvertisingFeeCheck",
                component: () =>
                    import(
                        "@/views/Finance/Independent/AdvertisingFeeCheck/AdvertisingFeeCheck"
                    ),
                meta: { title: "广告费核账" },
            },
            //财务管理_公司财务_中转仓财务
            {
                path: "TransitWarehouseFinance",
                name: "TransitWarehouseFinance",
                component: () =>
                    import(
                        "@/views/Finance/CompanyFinance/TransitWarehouseFinance/TransitWarehouseFinance"
                    ),
                meta: { title: "中转仓财务" },
            },
            //财务管理_公司财务_电商公司财务
            {
                path: "E-commerceCompanyFinance",
                name: "E-commerceCompanyFinance",
                component: () =>
                    import(
                        "@/views/Finance/CompanyFinance/E-commerceCompanyFinance/E-commerceCompanyFinance"
                    ),
                meta: { title: "电商公司财务" },
            },
            //财务管理_费用导入_店铺月租手续费导入
            {
                path: "StoreMonthlyFeeImport",
                name: "StoreMonthlyFeeImport",
                component: () =>
                    import(
                        "@/views/Finance/FeeImport/StoreMonthlyFeeImport/StoreMonthlyFeeImport"
                    ),
                meta: { title: "店铺月租手续费导入" },
            },
            //财务管理_费用导入_广告费导入
            {
                path: "AdvertisingFeeImport",
                name: "AdvertisingFeeImport",
                component: () =>
                    import(
                        "@/views/Finance/FeeImport/AdvertisingFeeImport/AdvertisingFeeImport"
                    ),
                meta: { title: "广告费导入" },
            },
            //财务管理_费用导入_回款导入
            {
                path: "RefundImport",
                name: "RefundImport",
                component: () =>
                    import("@/views/Finance/FeeImport/RefundImport/RefundImport"),
                meta: { title: "回款导入" },
            },
            //财务管理_费用导入_平台-订单退款导入
            {
                path: "PlatformOrderRefundImport",
                name: "PlatformOrderRefundImport",
                component: () =>
                    import(
                        "@/views/Finance/FeeImport/PlatformOrderRefundImport/PlatformOrderRefundImport"
                    ),
                meta: { title: "平台-订单退款导入" },
            },
            //财务管理_费用导入_PayPal费用导入
            {
                path: "PayPalFeeImport",
                name: "PayPalFeeImport",
                component: () =>
                    import("@/views/Finance/FeeImport/PayPalFeeImport/PayPalFeeImport"),
                meta: { title: "PayPal费用导入" },
            },
            //财务管理_费用导入_信用卡费用导入
            {
                path: "CreditCardFeeImport",
                name: "CreditCardFeeImport",
                component: () =>
                    import(
                        "@/views/Finance/FeeImport/CreditCardFeeImport/CreditCardFeeImport"
                    ),
                meta: { title: "信用卡费用导入" },
            },
            //财务管理_费用导入_FBA花费导入
            {
                path: "FBACostImport",
                name: "FBACostImport",
                component: () =>
                    import("@/views/Finance/FeeImport/FBACostImport/FBACostImport"),
                meta: { title: "FBA花费导入" },
            },
            //财务管理_店铺业绩_平台店铺业绩
            {
                path: "storPerformance",
                name: "storPerformance",
                component: () =>
                    import(
                        "@/views/Finance/StorePerformance/storPerformance/storPerformance"
                    ),
                meta: { title: "平台店铺业绩" },
            },
            //财务管理_店铺业绩_独立站店铺业绩
            {
                path: "IndependentStationPerformance",
                name: "IndependentStationPerformance",
                component: () =>
                    import(
                        "@/views/Finance/StorePerformance/IndependentStationPerformance/IndependentStationPerformance"
                    ),
                meta: { title: "独立站店铺业绩" },
            },
            //财务管理_员工利润统计
            {
                path: "EmployeeProfitStatistics",
                name: "EmployeeProfitStatistics",
                component: () =>
                    import(
                        "@/views/Finance/EmployeeProfitStatistics/EmployeeProfitStatistics"
                    ),
                meta: { title: "员工利润统计" },
            },
            //财务管理_收款平台统计_收款平台收入
            {
                path: "PaymentPlatformRevenue",
                name: "PaymentPlatformRevenue",
                component: () =>
                    import(
                        "@/views/Finance/CollectionPlatformStatistics/PaymentPlatformRevenue/PaymentPlatformRevenue"
                    ),
                meta: { title: "收款平台收入" },
            },
            //财务管理_收款平台统计_收款平台支出
            {
                path: "CollectionPlatformExpenses",
                name: "CollectionPlatformExpenses",
                component: () =>
                    import(
                        "@/views/Finance/CollectionPlatformStatistics/CollectionPlatformExpenses/CollectionPlatformExpenses"
                    ),
                meta: { title: "收款平台支出" },
            },
            //财务管理_收款平台统计_收款平台结余
            {
                path: "PaymentPlatformBalance",
                name: "PaymentPlatformBalance",
                component: () =>
                    import(
                        "@/views/Finance/CollectionPlatformStatistics/PaymentPlatformBalance/PaymentPlatformBalance"
                    ),
                meta: { title: "收款平台结余" },
            },
            //财务管理_薪资管理_个人底薪管理
            {
                path: "PersonalBasicSalaryManagement",
                name: "PersonalBasicSalaryManagement",
                component: () =>
                    import(
                        "@/views/Finance/SalaryManagement/PersonalBasicSalaryManagement/PersonalBasicSalaryManagement"
                    ),
                meta: { title: "个人底薪管理" },
            },
            //财务管理_薪资管理_考勤管理
            {
                path: "AttendanceManagement",
                name: "AttendanceManagement",
                component: () =>
                    import(
                        "@/views/Finance/SalaryManagement/AttendanceManagement/AttendanceManagement"
                    ),
                meta: { title: "考勤管理" },
            },
            //财务管理_薪资管理_提成管理
            {
                path: "CommissionManagement",
                name: "CommissionManagement",
                component: () =>
                    import(
                        "@/views/Finance/SalaryManagement/CommissionManagement/CommissionManagement"
                    ),
                meta: { title: "提成管理" },
            },
            //财务管理_薪资管理_个人综合薪资
            {
                path: "PersonalComprehensiveSalary",
                name: "PersonalComprehensiveSalary",
                component: () =>
                    import(
                        "@/views/Finance/SalaryManagement/PersonalComprehensiveSalary/PersonalComprehensiveSalary"
                    ),
                meta: { title: "个人综合薪资" },
            },
            //财务管理_财务体系_收支账户
            {
                path: "IncomeExpenditureAccount",
                name: "IncomeExpenditureAccount",
                component: () =>
                    import(
                        "@/views/Finance/SalaryManagement/FinancialSystem/IncomeExpenditureAccount"
                    ),
                meta: { title: "收支账户" },
            },
            //财务管理_财务体系_收支明细
            {
                path: "IncomeExpenditureDetails",
                name: "IncomeExpenditureDetails",
                component: () =>
                    import(
                        "@/views/Finance/SalaryManagement/FinancialSystem/IncomeExpenditureDetails"
                    ),
                meta: { title: "收支明细" },
            },
            //财务管理_财务体系_结算总账
            {
                path: "Settlementledger",
                name: "Settlementledger",
                component: () =>
                    import(
                        "@/views/Finance/SalaryManagement/FinancialSystem/Settlementledger"
                    ),
                meta: { title: "结算总账" },
            },
            //财务管理_财务体系_项目分账
            {
                path: "ProjectAccountSharing",
                name: "ProjectAccountSharing",
                component: () =>
                    import(
                        "@/views/Finance/SalaryManagement/FinancialSystem/ProjectAccountSharing"
                    ),
                meta: { title: "项目分账" },
            },
            //财务管理_财务体系_账户-店铺
            {
                path: "AccountSeller",
                name: "AccountSeller",
                component: () => import("@/views/Finance/SalaryManagement/FinancialSystem/AccountSeller"),
                meta: { title: "账户-店铺" },
            },
            //财务管理_财务体系_明细核对
            {
                path: "DetailedCheck",
                name: "DetailedCheck",
                component: () => import("@/views/Finance/SalaryManagement/FinancialSystem/DetailedCheck"),
                meta: { title: "明细核对" },
            },
            // 亚马逊赶跟卖_手动赶跟卖_买家账号购买
            {
                path: "BuyerAccountPurchase",
                name: "BuyerAccountPurchase",
                component: () =>
                    import(
                        "@/views/AmazonRushesToSell/ManualFollowUp/BuyerAccountPurchase"
                    ),
                meta: { title: "买家账号购买" },
            },
            // 亚马逊赶跟卖_手动赶跟卖_买家账号审批
            {
                path: "BuyerAccountApproval",
                name: "BuyerAccountApproval",
                component: () =>
                    import(
                        "@/views/AmazonRushesToSell/ManualFollowUp/BuyerAccountApproval"
                    ),
                meta: { title: "买家账号审批" },
            },
            // 亚马逊赶跟卖_手动赶跟卖_买家账号使用记录
            {
                path: "BuyerAccountUsageRecord",
                name: "BuyerAccountUsageRecord",
                component: () =>
                    import(
                        "@/views/AmazonRushesToSell/ManualFollowUp/BuyerAccountUsageRecord"
                    ),
                meta: { title: "买家账号使用记录" },
            },
            // 亚马逊赶跟卖_手动赶跟卖_买家账号参数设置
            {
                path: "BuyerAccountParameterSettings",
                name: "BuyerAccountParameterSettings",
                component: () =>
                    import(
                        "@/views/AmazonRushesToSell/ManualFollowUp/BuyerAccountParameterSettings"
                    ),
                meta: { title: "买家账号参数设置" },
            },
            {
                path: "OrderResourceAllocation",
                name: "OrderResourceAllocation",
                component: () =>
                    import(
                        "@/views/AmazonRushesToSell/ManualFollowUp/OrderResourceAllocation"
                    ),
                meta: { title: "下单资源配置" },
            },

            // 亚马逊赶跟卖_手动赶跟卖_买家账号申请记录
            {
                path: "BuyerAccountApplicationRecord",
                name: "BuyerAccountApplicationRecord",
                component: () =>
                    import(
                        "@/views/AmazonRushesToSell/ManualFollowUp/BuyerAccountApplicationRecord"
                    ),
                meta: { title: "买家账号申请记录" },
            },
            // 亚马逊赶跟卖_手动赶跟卖_手动赶跟卖费用统计_手动下单配置费用
            {
                path: "ManualOrderConfigurationFee",
                name: "ManualOrderConfigurationFee",
                component: () =>
                    import(
                        "@/views/AmazonRushesToSell/ManualFollowUp/ManuallyCatchUpAndSellCostStatistics/ManualOrderConfigurationFee"
                    ),
                meta: { title: "手动下单配置费用" },
            },
            // 亚马逊赶跟卖_手动赶跟卖_手动赶跟卖费用统计_手动下单使用费用明细
            {
                path: "ManualOrderUsageFeeDetails",
                name: "ManualOrderUsageFeeDetails",
                component: () =>
                    import(
                        "@/views/AmazonRushesToSell/ManualFollowUp/ManuallyCatchUpAndSellCostStatistics/ManualOrderUsageFeeDetails"
                    ),
                meta: { title: "手动下单使用费用明细" },
            },
            //服务管理
            {
                path: "ServiceManage",
                name: "ServiceManage",
                component: () => import("@/views/ServiceManage"),
                meta: { title: "服务管理" },
            },
            //商务管理
            {
                path: "BusinessManage",
                name: "BusinessManage",
                component: () => import("@/views/BusinessManage"),
                meta: { title: "商务管理" },
            },
            //权限管理_店铺授权
            {
                path: "amazonLicensing",
                component: () => import("@/views/jurisdiction/Ymx_authorization"),
                meta: { title: "店铺授权" },
                name: "amazonLicensing",
            },
            //权限管理_亚马逊授权_亚马逊授权方法
            {
                path: "Ymx_authorization_help",
                component: () =>
                    import("@/views/jurisdiction/Ymx_authorization_help"),
                name: "Ymx_authorization_help",
                hidden: true,
            },
            //权限管理_用户管理
            {
                path: "userManagement",
                component: () => import("@/views/jurisdiction/role"),
                meta: { title: "用户管理" },
                name: "userManagement",
            },
            //权限管理_角色管理
            {
                path: "roleManagement",
                component: () => import("@/views/jurisdiction/user/user"),
                meta: { title: "角色管理" },
                name: "roleManagement",
            },
            //权限管理_分公司角色管理
            {
                path: "BranchRoleManagement",
                component: () => import("@/views/jurisdiction/BranchRoleManagement"),
                meta: { title: "分公司角色管理" },
                name: "BranchRoleManagement",
            },
            //权限管理_总公司角色管理
            {
                path: "HeadquartersRoleManagement",
                component: () =>
                    import("@/views/jurisdiction/HeadquartersRoleManagement"),
                meta: { title: "总公司角色管理" },
                name: "HeadquartersRoleManagement",
            },
            //采购管理_订单采购
            {
                path: "OrderPurchase",
                name: "OrderPurchase",
                component: () => import("@/views/Purchase/Orderpurchase"),
                meta: { title: " 订单采购" },
            },
            //采购管理_库存采购
            {
                path: "StockPurchase",
                name: "StockPurchase",
                component: () => import("@/views/Purchase/Stockpurchase"),
                meta: { title: " 库存采购" },
            },
            //采购管理_其他采购
            {
                path: "OtherPurchases",
                name: "OtherPurchases",
                component: () => import("@/views/Purchase/Otherprocurement"),
                meta: { title: " 其他采购" },
            },
            //采购管理_退件记录
            {
                path: "Returnrecord",
                name: "Returnrecord",
                component: () => import("@/views/Purchase/Returnrecord"),
                meta: { title: " 退件记录" },
            },
            //采购管理_到货统计
            {
                path: "ArrivaStatistics",
                name: "ArrivaStatistics",
                component: () => import("@/views/Purchase/ArrivaStatistics"),
                meta: { title: " 到货统计" },
            },
            //库存管理_自建库存
            {
                path: "SelfBuiltInventory",
                name: "SelfBuiltInventory",
                component: () => import("@/views/Stock/build_by_oneself"),
                meta: { title: " 自建库存" },
            },
            //库存管理_异常库存
            {
                path: "AbnormalInventory",
                name: "AbnormalInventory",
                component: () => import("@/views/Stock/abnormal"),
                meta: { title: " 异常库存" },
            },
            //库存管理_未知库存
            {
                path: "UnknownInventory",
                name: "UnknownInventory",
                component: () => import("@/views/Stock/Unknown"),
                meta: { title: " 未知库存" },
            },
            //库存管理_出入库记录
            {
                path: "InventoryHistoryRecord",
                name: "InventoryHistoryRecord",
                component: () => import("@/views/Stock/InventoryHistoryRecord"),
                meta: { title: " 出入库记录" },
            },
            //库存管理_COD退件
            {
                path: "codReturnDetails",
                name: "codReturnDetails",
                component: () => import("@/views/Stock/COMparticulars"),
                meta: { title: " COD退件明细" },
            },
            //库存管理_COD退件统计
            {
                path: "codReturnStatistics",
                name: "codReturnStatistics",
                component: () => import("@/views/Stock/CODdecline"),
                meta: { title: " COD退件统计" },
            },
            //库存管理_COD重派
            {
                path: "codReassign",
                name: "codReassign",
                component: () => import("@/views/Stock/CODrearrange"),
                meta: { title: " COD重派" },
            },
            //库存管理_COD货态
            {
                path: "codCargoStatus",
                name: "codCargoStatus",
                component: () => import("@/views/Stock/codCargoStatus"),
                meta: { title: " COD货态" },
            },
            //用户中心_个人信息
            {
                path: "personalInformation",
                name: "personalInformation",
                component: () => import("@/views/usermanagement/Usermanagement"),
                meta: { title: "个人信息" },
            },
            //用户中心_工资详情
            {
                path: "salaryDetails",
                name: "salaryDetails",
                component: () => import("@/views/usermanagement/property"),
                meta: { title: "工资详情" },
            },
            //系统维运_UPC/EAN码管理
            {
                path: "upcAdministration",
                name: "upcAdministration",
                component: () => import("@/views/system/upcAdministration"),
                meta: { title: "UPC/EAN码管理" },
            },
            //系统维运_总后台设置
            {
                path: "TotalBackgroundSettings",
                name: "TotalBackgroundSettings",
                component: () => import("@/views/system/TotalBackgroundSettings"),
                meta: { title: "总后台设置" },
            },
            //系统维运_总后台设置
            // {
            //   path: 'TotalBackgroundSettingscopy',
            //   name: 'TotalBackgroundSettingscopy',
            //   component: () =>
            //     import('@/views/system/TotalBackgroundSettings copy'),
            //   meta: { title: '总后台设置w' },
            // },
            //系统维运_总后台设置
            {
                path: "commonWords",
                name: "commonWords",
                component: () => import("@/views/system/commonWords"),
                meta: { title: "工单常用语" },
            },
            //系统维运_总后台设置
            {
                path: "abnormalWords",
                name: "abnormalWords",
                component: () => import("@/views/system/abnormalWords"),
                meta: { title: "异常常用语" },
            },
            //系统维运_总后台设置
            {
                path: "remarkStandard",
                name: "remarkStandard",
                component: () => import("@/views/system/remarkStandard"),
                meta: { title: "采购需求标准" },
            },
            //系统维运_总后台设置
            {
                path: "Question",
                name: "Question",
                component: () => import("@/views/system/Question"),
                meta: { title: "常见问题" },
            },
            //物流管理_仓库管理
            {
                path: "Warehouse",
                name: "Warehouse",
                component: () => import("@/views/logistics/Warehouse"),
                meta: { title: " 仓库管理" },
            },
            //物流管理_信息部
            {
                path: "information",
                name: "information",
                component: () => import("@/views/logistics/information"),
                meta: { title: "信息部" },
            },
            //物流管理_渠道部
            {
                path: "channe",
                name: "channe",
                component: () => import("@/views/logistics/channel"),
                meta: { title: " 渠道部" },
            },
            {
                path: "recordSKU",
                name: "recordSKU",
                component: () => import("@/views/logistics/recordSKU"),
                meta: { title: " 备案SKU" },
            },
            {
                path: "channelConfigure",
                name: "channelConfigure",
                component: () => import("@/views/logistics/channelConfigure"),
                meta: { title: "渠道配置" },
            },
            //物流管理_操作部
            {
                path: "operation",
                name: "operation",
                component: () => import("@/views/logistics/operation"),
                meta: { title: " 操作部" },
            },
            //物流管理_服务部
            {
                path: "service",
                name: "service",
                component: () => import("@/views/logistics/service"),
                meta: { title: " 服务部" },
            },
            //物流管理_仓储部
            {
                path: "storage",
                name: "storage",
                component: () => import("@/views/logistics/storage"),
                meta: { title: " 仓储部" },
            },
            //物流管理_流转管理
            {
                path: "Circulationmanagement",
                name: "Circulationmanagement",
                component: () => import("@/views/logistics/Circulationmanagement"),
                meta: { title: " 流转管理" },
            },
            //物流管理_财务申报0
            {
                path: "Financialdeclaration",
                name: "Financialdeclaration",
                component: () => import("@/views/logistics/Financialdeclaration"),
                meta: { title: " 财务申报" },
            },
            //物流管理_运费审核
            {
                path: "FreightReview",
                name: "FreightReview",
                component: () => import("@/views/logistics/FreightReview"),
                meta: { title: " 运费审核" },
            },
            //物流管理_操作记录
            {
                path: "Operationrecord",
                name: "Operationrecord",
                component: () => import("@/views/logistics/Operationrecord"),
                meta: { title: " 操作记录" },
            },
            //物流管理_国际物流
            {
                path: "InternationalLogistics",
                name: "InternationalLogistics",
                component: () => import("@/views/logistics/InternationalLogistics"),
                meta: { title: " 国际物流" },
            },
            {
                path: "Aftersalesservice",
                name: "Aftersalesservice",
                component: () => import("@/views/logistics/AfterSingle"),
                meta: { title: " 售后单" },
            },
            //海逊商城_商品匹配单
            {
                path: "CommodityMatchingList",
                name: "CommodityMatchingList",
                component: () => import("@/views/joinMatching/commoditieslist"),
                meta: { title: " 商品订单" },
            },
            //海逊商城_海逊商品列表
            {
                path: "ProductList",
                name: "ProductList",
                component: () => import("@/views/joinMatching/Matchinglist"),
                meta: { title: " 海逊商品列表" },
            },
            //海逊商城_海逊商城产品
            {
                path: "HisunMallProducts",
                name: "HisunMallProducts",
                component: () =>
                    import("@/views/joinMatching/ShoppingMall/HxShoppingMall"),
                meta: { title: " 海逊商城产品" },
            },
            //添加信息
            {
                path: "addInformation",
                name: "addInformation",
                component: () => import("@/views/information/addInformation"),
                meta: { title: " 公告发布" },
            },
            // 平台 公告 - 信息 列表
            {
                path: "noticeList/:pageType",
                name: "noticeList",
                component: () => import("@/views/information/noticeList"),
                meta: { title: "公告发布" },
            },
            // 教学视频
            {
                path: "Teachingvideo",
                name: "Teachingvideo",
                component: () => import("@/views/Teachingvideo"),
                meta: { title: "教学视频" },
            },
            // 侵权词汇
            {
                path: "Tortvocabulary",
                name: "Tortvocabulary",
                component: () => import("@/views/Tortvocabulary"),
                meta: { title: "侵权词汇" },
            },
            // 建议箱
            {
                path: "SuggestionBox",
                name: "SuggestionBox",
                component: () => import("@/views/SuggestionBox"),
                meta: { title: "建议箱" },
            },
            // 站点监听
            {
                path: "SiteMonitoring",
                name: "SiteMonitoring",
                component: () => import("@/views/siteMonitoring/SiteMonitoring"),
                meta: { title: "站点监听" },
            },
            // // TB广告_广告统计
            // {
            //   path: 'Advertise',
            //   name: 'Advertise',
            //   component: () => import('@/views/Taboola/Advertise'),
            //   meta: { title: '广告统计报表' },
            // },
            // // TB广告_活动
            // {
            //   path: 'Campaigns',
            //   name: 'Campaigns',
            //   component: () => import('@/views/Taboola/Campaigns'),
            //   meta: { title: '活动列表' },
            // },
            // // TB广告_广告
            // {
            //   path: 'Advertising',
            //   name: 'Advertising',
            //   component: () => import('@/views/Taboola/advertising'),
            //   meta: { title: '静态广告列表' },
            // },
            // // TB广告_广告
            // {
            //   path: 'AdvertisingActive',
            //   name: 'AdvertisingActive',
            //   component: () => import('@/views/Taboola/advertisingActive'),
            //   meta: { title: '动态广告列表' },
            // },
            // // TB广告_追踪事件
            // {
            //   path: 'Tracking',
            //   name: 'Tracking',
            //   component: () => import('@/views/Taboola/Tracking'),
            //   meta: { title: '追踪事件' },
            // },
            {
                path: "shopeeProductDisplay",
                name: "ShopeeProductDisplay",
                component: () => import("@/views/shopee/productDisplay.vue"),
                meta: { title: "全球刊登" },
            },
            {
                path: "shopeeOnlineProduct",
                name: "ShopeeOnlineProduct",
                component: () => import("@/views/shopee/onlineProduct.vue"),
                meta: { title: "在线产品" },
            },
        ],
    },
    //项目管理
    {
        path: "/projectManagement",
        component: () => import("@/views/ProjectManagement/Layout.vue"),
        meta: { title: "项目管理", requiresAuth: true},
        redirect: '/projectManagement/main',
        name: 'project',
        children:[
            {
                path: "main",
                name: "projectManagement",
                component: () => import("@/views/ProjectManagement/Main.vue"),
                meta: { title: "项目管理", requiresAuth: true },
            },
            {
                path: "budgetManagement",
                name: "budgetManagement",
                component: () => import("@/views/ProjectManagement/BudgetManagement.vue"),
                meta: { title: "预算管理", requiresAuth: true },
            },
            {
                path: "costDetails",
                name: "costDetails",
                component: () => import("@/views/ProjectManagement/CostDetails.vue"),
                meta: { title: "费用明细", requiresAuth: true },
            },
            {
                path: "resourceConfiguration",
                name: "resourceConfiguration",
                component: () => import("@/views/ProjectManagement/ResourceConfiguration.vue"),
                meta: { title: "资源配置", requiresAuth: true },
            },
            {
                path: "financialReports",
                name: "financialReports",
                component: () => import("@/views/ProjectManagement/FinancialReports.vue"),
                meta: { title: "财务报告", requiresAuth: true },
            },
        ]
    },
    // 图片翻译编辑器
    {
        path: "/ImageTranslationEditor",
        name: "imageTranslationEditor",
        component: () => import("@/views/imageTranslationEditor/Main"),
        meta: { title: "图片翻译编辑器", requiresAuth: true },
    },

    {
        path: "*",
        redirect: "/404",
        hidden: true,
    },
];